module.exports = __webpack_public_path__ + "static/09-8b0eab31eeca79fc3010b1acb85d8d3d.jpg";